import {
  get,
} from '../axios'

class Salesman {
  async getSalesman(param) {
    const res = await get('/Salesman/GetSalesman', param)
    return res
  }
}
export default new Salesman()